import {ConversationId, Region} from "platformed-client/types";

// Batcher keys for the live counter refetch. A batch can span regions (the
// list is cross-region), so a key carries its region and the fetcher groups by
// it; `conversation_id` is globally unique, so the resolver matches on it
// alone. Kept free of the `api` import so it's unit-testable in isolation.

export function encodeCounterKey(region: Region, conversationId: ConversationId): string {
  return `${region}/${conversationId}`;
}

export function decodeCounterKey(key: string): {region: Region; conversationId: ConversationId} {
  const slash = key.indexOf("/");
  return {region: key.slice(0, slash) as Region, conversationId: key.slice(slash + 1) as ConversationId};
}

export function groupCounterKeysByRegion(keys: string[]): Map<Region, ConversationId[]> {
  const byRegion = new Map<Region, ConversationId[]>();
  for (const key of keys) {
    const {region, conversationId} = decodeCounterKey(key);
    const ids = byRegion.get(region) ?? [];
    ids.push(conversationId);
    byRegion.set(region, ids);
  }
  return byRegion;
}
